export default __webpack_public_path__ + "static/media/oil_qr_code.69090b85.png";